module.exports = __webpack_public_path__ + "img/f-thermometer-img5-2.454618b3.png";